import {doc, FirestoreDataConverter, getDoc, collection, query, where, getDocs} from "firebase/firestore";
import {db} from "@/main";

const vacationPeriodConverter: FirestoreDataConverter<VacationPeriod> = {
    toFirestore(data: VacationPeriod) {
        return data;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            ...data,
            deadline: data.deadline.toDate(),
            startDate: data.startDate.toDate(),
            endDate: data.endDate.toDate(),
        } as VacationPeriod;
    }
};

export function GetVacationPeriod(year: string): Promise<VacationPeriod> {
    return new Promise<VacationPeriod>((resolve, reject) => {
        const wishPeriodRef = doc(db, "vacationPeriods", year).withConverter(vacationPeriodConverter);
        getDoc(wishPeriodRef)
            .then((doc) => {
                if (doc.exists()) {
                    resolve(doc.data() as VacationPeriod);
                } else {
                    reject("No vacationPeriod found!");
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function GetVacationPeriodsData(): Promise<VacationPeriod[]> {
     return new Promise<VacationPeriod[]>(async (resolve, reject) => {
        try {
            const wishPeriodsRef = collection(db, "vacationPeriods").withConverter(vacationPeriodConverter);

            const wishPeriodsDataQuery = query(
                wishPeriodsRef,
                where("hidden", "==", false),
                where("approved", "==", true)
            );

            const wishPeriodsDataSnapshot = await getDocs(wishPeriodsDataQuery);

            if (!wishPeriodsDataSnapshot.empty) {
                
                const returnWishPeriodsData: VacationPeriod[] = [];
                for (const wishPeriodsData of wishPeriodsDataSnapshot.docs) {
                    returnWishPeriodsData.push({...wishPeriodsData.data(), dates: []} as VacationPeriod);
                }
                resolve(returnWishPeriodsData);

            } else {
                reject("No matching vacationwishPeriods found!");
            }
        } catch (error) {
            reject(error);
        }
    })
}

export function CheckVacationPeriod(year: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
        const wishPeriodRef = doc(db, "vacationPeriods", year)
        getDoc(wishPeriodRef)
            .then((doc) => {
                console.log(doc.exists());
                if (doc.exists()) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
}